/* 🤖 this file was generated by svg-to-ts */
export const emperorIconCalendarRefresh2: {
  name: 'calendar_refresh_2';
  data: string;
} = {
  name: 'calendar_refresh_2',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0-.01h24v24H0Z"/><g><path d="M15.69 10.314c-.91-1.03-2.22-1.69-3.7-1.69 -2.76 0-5 2.24-5 5 0 2.75 2.24 5 5 5 2.279 0 4.18-1.55 4.785-3.63h-2.14c-.5.96-1.5 1.63-2.66 1.63 -1.654 0-3-1.346-3-3s1.346-3 3-3c.81 0 1.54.33 2.08.85l-2.09 1.51h5V9.35l-1.31.94Z"/><path d="M21 3h-3V1h-2v6h2V5h3v15H3V5h2V3H3c-1.11 0-2 .89-2 2v15c0 1.1.89 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.11-.9-2-2-2Z"/><path d="M15 3L8 3l0-2L6 1l0 6 2 0 0-2 7 0Z"/></g></svg>`
};
